//@flow

import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import DefaultButton from './../../../components/DefaultButton';
import GhostButton from './../../../components/GhostButton';
import TextArea from './../../../components/TextArea';
import { translate } from "react-i18next";
import messageManager from './../../../utilities/messageManager';
import loading from './../../../utilities/loading';
import {
    getCommentsSuccess,
    startDrawingCommentGeometry,
    finishDrawingCommentGeometry,
    cancelDrawingCommentGeometry,
    selectComment,
} from './../../../actions/comments';
import { setEditMode } from './../../../actions/map';

const SidebarCover = styled.div`
    left: 0;
    height: calc(100% - 32px);
    width: 100%;
    position: absolute;
    z-index: 1;
    background-color: #fcfcfc;
    color: #1f1f1f;
    top: 32px;
    display:flex;
    flex-direction: column;
    align-items: center;
`;

const SidebarContent = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 20px);
`;
const CreatorTitle = styled.h3`
    margin: 10px 0 5px;
    color: #265a9c;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
`;

const Tip = styled.p`
    white-space: pre-wrap;
`;

const ButtonWrapper = styled.div`
    display: flex;    
`;

export const saveCommentCallback = {
    callbacks: [],
    subscribe: function (callback) {
        this.callbacks.push(callback);
    },
    run: function () {
        for (let i = 0; i < this.callbacks.length; i++) {
            if (typeof this.callbacks[i] === 'function')
                this.callbacks[i]();
        }
    }
}

class FlightCreator extends React.Component {
    constructor(props) {
        super();
        this.state = {
            editedFeature: { text: '', geomWkt: '' },
            createButtonDisabled: false,
            isDrawing: false,
        }
    }

    componentDidUpdate(prevProps) {
        const { editMode, selectedComment, visible } = this.props;
        const { editedFeature } = this.state;
        if (prevProps.visible === false && visible === true) {
            if (editMode && !_.isEqual(editedFeature, selectedComment)) {
                this.setState({ editedFeature: _.cloneDeep(selectedComment) });
            }
            else if (!_.isEmpty(editedFeature)) {
                this.setState({ editedFeature: { text: '', geomWkt: '' } });
            }
        }

        if (prevProps.drawingComment !== this.props.drawingComment
            && (this.props.drawingComment === 'finished' || this.props.drawingComment === 'canceled')) {
            this.setState({
                isDrawing: false
            })
        }
    }

    createComment(callback) {
        const { BASE_URL, axiosInstance, getCommentsSuccess, t, comments, hideCommentCreator, selectComment } = this.props;
        const { editedFeature } = this.state;
        loading.start();
        this.setState({ createButtonDisabled: true });
        axiosInstance.post(`${BASE_URL}comments`, editedFeature)
            .then(response => {
                const { data } = response;
                getCommentsSuccess([data].concat(comments));
                selectComment(data);

                this.setState({ createButtonDisabled: false });
                loading.stop();
                hideCommentCreator();
                messageManager.show({
                    text: t('Comment created'),
                    type: 'info',
                })
            })
            .catch((error) => {
                loading.stop();
                this.setState({ createButtonDisabled: false });
                messageManager.show({
                    text: t(error.response.data),
                    type: 'error',
                })
                hideCommentCreator();
            })
            .then(() => {
                callback();
                saveCommentCallback.run();
            })
    }

    editComment(callback) {
        const { BASE_URL, axiosInstance, getCommentsSuccess, t, comments, hideCommentCreator, selectComment } = this.props;
        const { editedFeature } = this.state;
        loading.start();
        this.setState({ createButtonDisabled: true });
        axiosInstance.put(`${BASE_URL}comments/${editedFeature.id}`, editedFeature)
            .then(response => {
                const editedComments = comments.map(comment => {
                    if (comment.id === editedFeature.id) {
                        return editedFeature
                    }
                    return comment;
                })
                getCommentsSuccess(editedComments);
                selectComment(editedFeature);

                this.setState({ createButtonDisabled: false });
                loading.stop();
                hideCommentCreator();
                messageManager.show({
                    text: t('Comment edited'),
                    type: 'info',
                })
            })
            .catch((error) => {
                loading.stop();
                this.setState({ createButtonDisabled: false });
                messageManager.show({
                    text: t(error.response.data),
                    type: 'error',
                })
                hideCommentCreator();
            })
            .then(() => {
                callback();
                saveCommentCallback.run();
            })
    };


    render() {
        const { visible, t, hideCommentCreator, cancelEditMode, editMode } = this.props;
        const { createButtonDisabled, editedFeature } = this.state;
        if (visible) {
            return (
                <SidebarCover>
                    <SidebarContent>
                        <CreatorTitle>
                            {editMode
                                ? <b>{`${t('Edit comment')}`}</b>
                                : <b>{`${t('New comment')}`}</b>
                            }
                        </CreatorTitle>
                        <TextArea
                            style={{ alignItems: 'flex-start', height: '150px' }}
                            tip={null}
                            type='text'
                            value={editedFeature.text}
                            onChange={(e) => {
                                this.setState({
                                    editedFeature: { ...editedFeature, text: e.target.value }
                                });
                            }}
                            placeholder={t('It is a good day for flying') || ''} />
                        <Tip>
                            {t('Click on the button then on the map to mark comment')}
                        </Tip>
                        <ButtonWrapper>
                            <GhostButton
                                style={{
                                    height: '25px',
                                    width: '130px',
                                    marginRight: '5px',
                                }}
                                visible={this.state.isDrawing}
                                title={t('Finish drawing')}
                                onClick={() => {
                                    this.props.finishDrawingCommentGeometry();
                                    this.setState({ isDrawing: false })
                                }}>
                                {t('Finish drawing')}
                            </GhostButton>
                            <DefaultButton
                                style={{
                                    height: '25px',
                                    width: '130px',
                                }}
                                visible={!this.state.isDrawing}
                                title={t('Draw geometry')}
                                onClick={() => {
                                    this.props.startDrawingCommentGeometry(editedFeature);
                                    this.setState({ isDrawing: true })
                                }}>
                                {t('Draw geometry')}
                            </DefaultButton>
                        </ButtonWrapper>
                        <GhostButton
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                right: '85px',
                                height: '25px',
                                width: '55px',
                            }}
                            title={t('Cancel')}
                            onClick={() => {
                                cancelEditMode();
                                hideCommentCreator();
                                this.props.cancelDrawingCommentGeometry();
                                this.setState({
                                    editedFeature: {},
                                    isDrawing: false
                                });
                                this.props.setEditMode(false);
                            }}>
                            {t('Cancel')}
                        </GhostButton>
                        <DefaultButton
                            disabled={createButtonDisabled || editedFeature.text === ''}
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                right: '20px',
                                height: '25px',
                                width: '55px',
                            }}
                            title={t('Save')}
                            onClick={() => {
                                if (editMode)
                                    this.editComment(() => {
                                        this.setState({
                                            isDrawing: false,
                                            editedFeature: {}
                                        })
                                    });
                                else
                                    this.createComment(() => {
                                        this.setState({
                                            isDrawing: false,
                                            editedFeature: {}
                                        })
                                    });
                                this.props.finishDrawingCommentGeometry();
                                cancelEditMode();
                                this.props.setEditMode(false);
                            }}>
                            {t('Save')}
                        </DefaultButton>
                    </SidebarContent>
                </SidebarCover >
            );
        }
        else return null;
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    drawingComment: state.comments.get('drawingComment'),
    selectedComment: state.comments.get('selectedComment'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    getCommentsSuccess,
    startDrawingCommentGeometry,
    finishDrawingCommentGeometry,
    cancelDrawingCommentGeometry,
    selectComment,
    setEditMode,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps, null)(FlightCreator));


// WEBPACK FOOTER //
// ./src/containers/content/commentsManager/CommentCreator.jsx